module.exports = __webpack_public_path__ + "img/Attack_Goldtornado.6cbdc358.png";